import {
  Slide,
  Dialog,
  Box,
  Typography,
  TextField,
  useTheme,
  List,
  ListItem,
  ListItemText,
  Button,
} from "@material-ui/core";
import { TransitionProps } from "@material-ui/core/transitions";
import React from "react";
import { Close } from "@material-ui/icons";
import { useSelector } from "react-redux";
import {
  selectCollections,
  selectSelectedCollection,
} from "../../store/collection/collection.selector";
import { Autocomplete } from "@material-ui/lab";
import { CollectionService, VectorAIService } from "../../services";
import { NAV_BAR } from "../navigator/navigator.component";
import { useHistory } from "react-router-dom";

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & { children?: React.ReactElement },
  ref: React.Ref<unknown>
) {
  return <Slide direction="right" ref={ref} {...props} />;
});

interface IProps {
  open: boolean;
  onClose: () => void;
}

const HeaderDialogComponent: React.FC<IProps> = ({ open, onClose }) => {
  const collections = useSelector(selectCollections);
  const selectedCollection = useSelector(selectSelectedCollection);
  const theme = useTheme();
  const history = useHistory();

  const handleCollectionChange = (collectionName: string | null) => {
    if (collectionName) {
      CollectionService.selectCollection(collectionName);
    }
    if (history.location.pathname === "/") {
      history.push("/aggregation");
    }
    onClose();
  };

  const handleLogout = () => {
    VectorAIService.logout();
    history.replace("/login");
  };

  const handleNavigation = (path: string) => {
    history.push(path);
    onClose();
  };

  return (
    <Dialog open={open} fullScreen TransitionComponent={Transition}>
      <Box display="flex" flexGrow={1} flexDirection="column" p={2}>
        <Close color="disabled" fontSize="large" onClick={onClose} />
        <Box mt={2} display="flex" flexGrow={1} flexDirection="column">
          <Typography
            color="secondary"
            style={{ marginBottom: theme.spacing(1) }}
          >
            Current collection
          </Typography>
          <Autocomplete
            value={selectedCollection.data?.name || ""}
            onChange={(_, value) => handleCollectionChange(value)}
            options={collections.data || []}
            renderInput={(params) => (
              <TextField
                {...params}
                placeholder="Select collection"
                variant="outlined"
              />
            )}
          />
          <List
            style={{
              marginTop: theme.spacing(2),
              marginBottom: theme.spacing(2),
            }}
          >
            {NAV_BAR.map((element) => (
              <ListItem
                onClick={() => handleNavigation(element.path)}
                key={element.path}
                style={{
                  marginBottom: theme.spacing(1),
                  borderRadius: theme.shape.borderRadius,
                  backgroundColor:
                    history.location.pathname === element.path
                      ? theme.palette.primary.main
                      : theme.palette.common.white,
                  color:
                    history.location.pathname === element.path
                      ? theme.palette.common.white
                      : theme.palette.common.black,
                }}
              >
                <ListItemText primary={element.title}></ListItemText>
              </ListItem>
            ))}
          </List>
        </Box>

        <Button
          fullWidth
          color="primary"
          variant="contained"
          disableRipple
          disableElevation
          style={{
            textTransform: "none",
          }}
          onClick={handleLogout}
        >
          Logout
        </Button>
      </Box>
    </Dialog>
  );
};

export default HeaderDialogComponent;
